var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-calendar-content"},[_c('v-date-picker',{attrs:{"masks":_vm.masks,"first-day-of-week":1,"color":"gray","columns":_vm.$screens(_vm.columnAttr),"rows":_vm.$screens(_vm.rowAttr),"is-range":"","is-expanded":"","min-date":_vm.minDate},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }